export enum PriceItemDataHooks {
  Item = 'price-item',
  Label = 'price-item-label',
  Price = 'price-item-description',
  PriceBeforeDiscount = 'price-before-discount',
  DiscountRuleName = 'discount-rule-name',
  DiscountTooltip = 'discount-tooltip',
  CalculatedAtCheckout = 'calculated-at-checkout',
}
